module.exports = __webpack_public_path__ + "img/tie_mark.78256dac.svg";